export const AUTH = "/auth";
export const VERIFY_EMAIL = "/verify";
export const FORGET_PASSWORD = "/forget-password";
export const UPDATE_PASSWORD = "/update-password";
export const SIGN_UP = "/sign-up";

export const HOME = "/home";
export const ROUTE = "/";

export const PRODUCTS = "/products/:id";
export const MY_CAMPAIGNS_LIST = "/myCampaignsList";
export const MY_CAMPAIGNS_LIST_ADVANCE = "/myCampaignsListAdvance";

export const SETTING = '/setting';
export const CAMPAIGN_DETAILS = "/campaignDetails";
export const MY_REQUESTS_LIST = "/myRequestsList";
export const ADMIN_REQUEST_LIST = "/adminRequestList";

export const PLAY_CAMPAIGN = "/start-plan";
export const NEW_DASHBOARD = "/campaignDashboard/:id?/:clicked";

export const MY_PLANS_LIST = "/myPlansList";

export const USERS = "/users";

export const MY_CREATIVES = "/my-creatives";

export const CAMPAIGN_DETAILS_PAGE = "/campaignDetails/:id";

export const MEDIA_OWNER_PAGE = "/media-owner";
export const ADVERTISERS_PAGE = "/advertisers";
export const DATA_HERO = "/data-hero";


export const REGULARPLAN = "/regularplan/:id?";
export const SPECIALDAYPLAN = "/specialdayplan/:id?";
export const TRIGGERBASEDPLAN = "/triggerbasedplan/:id?";
export const IKNOWITALLPLAN = "/iknowitallplan/:id?";

export const PLAY_LIVE_URL = "/play-live-url";
export const BRAND_AGENCY_PAGE = "/brand-agency";
export const ORGANIZATION_PAGE = "/organization";